// extracted by css-extract-rspack-plugin
export default {"container":"container-fIXcRm","column":"column-p5oTjN","sliderGroup":"sliderGroup-bL4OLm"};